import { createBrowserHistory } from 'history';
import {createStore, applyMiddleware, compose} from "redux";
import createSagaMiddleware from "redux-saga";
import { connectRouter, routerMiddleware } from 'connected-react-router';

import reducer from "../reducers/index";
import rootSaga from "../sagas/index";

export const history = createBrowserHistory({
    basename: process.env.PUBLIC_URL
});

history.scrollRestoration = "manual";

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(connectRouter(history)(reducer),
  composeEnhancers(
    applyMiddleware(routerMiddleware(history), sagaMiddleware)));
sagaMiddleware.run(rootSaga);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js